import GridLoader from "react-spinners/GridLoader";
import tailwindTheme from "@/styles/tailwind.theme";

const LoadingGrid = ({ className = "" }: { className?: string }) => {
  const colors = tailwindTheme.theme.colors;

  return (
    <div className={`flex w-full items-center justify-center ${className}`}>
      <GridLoader color={colors.blue[100]} />
    </div>
  );
};

export default LoadingGrid;
